import httpClient from "./httpClient";

const prefix = "/mandatory-days";

export interface PartnerBonus {
  partnerId: number;
  bonus: number;
  partnerName?: string;
  branchName?: string;
}

export interface MandatoryDayData {
  date: string; // YYYY-MM-DD format
  partners: PartnerBonus[];
}

export async function getMandatoryDays(start?: string, end?: string): Promise<{ days: MandatoryDayData[] }> {
  const params: any = {};
  if (start) params.start = start;
  if (end) params.end = end;
  return (await httpClient.get(`${prefix}`, { params })).data;
}

export async function addMandatoryDay(date: string, partnerId: number, bonus: number): Promise<{ days: MandatoryDayData[] }> {
  return (await httpClient.post(`${prefix}`, { 
    date,
    partnerId,
    bonus
  })).data;
}

export async function createMandatoryDay(date: string): Promise<{ days: MandatoryDayData[] }> {
  return (await httpClient.post(`${prefix}`, { 
    date
  })).data;
}

export async function createMultipleMandatoryDays(dates: string[], partnerId?: number, bonus?: number): Promise<{ days: MandatoryDayData[] }> {
  const payload: any = { dates };
  if (partnerId !== undefined) payload.partnerId = partnerId;
  if (bonus !== undefined) payload.bonus = bonus;
  
  return (await httpClient.post(`${prefix}/multiple`, payload)).data;
}

export async function removeMandatoryDay(date: string): Promise<{ days: MandatoryDayData[] }> {
  return (await httpClient.delete(`${prefix}/day/${date}`)).data;
}

export async function removePartnerFromDate(date: string, partnerId: number): Promise<{ days: MandatoryDayData[] }> {
  return (await httpClient.delete(`${prefix}/day/${date}/partner/${partnerId}`)).data;
}

export async function bulkRemovePartners(partnerIds: number[]): Promise<{ days: MandatoryDayData[] }> {
  return (await httpClient.post(`${prefix}/bulk-remove-partners`, { partnerIds })).data;
}

export async function bulkCreateMandatoryDays(
  dates: string[], 
  partnerAssignments: Array<{ partnerId: number; bonus?: number }>
): Promise<{ days: MandatoryDayData[] }> {
  return (await httpClient.post(`${prefix}/bulk-create`, { 
    dates, 
    partnerAssignments 
  })).data;
}


